import Vue from 'vue'
import uuidv1 from 'uuid/v1'
import router from '../../router'

export const namespaced = true

export const defaultCheckinStep = ['guests', 'invoice', 'summary', 'payment', 'recognition', 'contract']

export const state = {
  submitting: false,
  loading: false,
  sidebarOpened: false,
  alerts: [],
  completedCheckinSteps: [],
  currentStep: 1,
}

export const mutations = {
  SUBMITTING_REQUEST(state, submitting) {
    state.submitting = submitting
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_SIDEBAR_STATUS(state, bolOpen) {
    state.sidebarOpened = bolOpen
  },
  ADD_ALERT(state, alertData) {
    state.alerts.push(alertData)
  },
  CLEAR_ALERTS(state) {
    state.alerts = []
  },
  REMOVE_ALERT(state, alertId) {
    state.alerts = state.alerts.filter(function(alert) {
      return alert.id !== alertId
    })
  },
  SET_STEPS(state, steps) {
    state.completedCheckinSteps = steps
  },
  SET_CURRENT_STEP(state, step) {
    state.currentStep = step
  },
}

export const actions = {
  toggle_sidebar({commit, state}) {
    commit('SET_SIDEBAR_STATUS', !state.sidebarOpened)
  },
  submitting_request({ commit }, submitting) {
    commit('SUBMITTING_REQUEST', submitting)
  },
  set_loading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setSidebarStatus({ commit }, bolOpen) {
    commit('SET_SIDEBAR_STATUS', bolOpen)
  },
  addAlert({ commit }, alertData) {
    if (!['success', 'info', 'warning', 'error'].includes(alertData.type)) return
    if (!!alertData.key && !!alertData.message) return
    alertData['id'] = uuidv1()
    commit('ADD_ALERT', alertData)
  },
  clearAlerts({ commit }) {
    commit('CLEAR_ALERTS')
  },
  replaceAlert({ dispatch }, alertData) {
    dispatch('clearAlerts')
    dispatch('addAlert', alertData)
  },
  removeAlert({ commit }, alertId) {
    commit('REMOVE_ALERT', alertId)
  },
  checkSteps({ commit, rootState }) {
    if (rootState.order?.order?.id && rootState.order?.reservationId) {
      const url = rootState.application.urls.checkin_steps
        .replace(':order_id', rootState.order.order.id)
        .replace(':reservation_id', rootState.order?.reservationId)

      return Vue.http.get(url)
        .then(response => {
          commit('SET_STEPS', response.data)
          
          let get_real_steps = response.data.map((ele) => ele.name)
          commit('SET_CURRENT_STEP', get_real_steps.indexOf(window.location.pathname.split('/').pop())+1)
          return response.data
        }).catch(error => {
          return error
        })
    }
  },
  goToStepper({ commit, state }, targetStep) {
    // console.log(`goToStepper from step ${state.currentStep} to ${targetStep}`)
    const targetSectionName = state.completedCheckinSteps[targetStep-1].name
    // console.log('  - targetSectionName', targetSectionName)
    commit('SET_CURRENT_STEP', targetStep)
    router.push({ name: `checkin${targetSectionName.charAt(0).toUpperCase() + targetSectionName.slice(1)}` })
  },
  goToNextStepper({ commit, state }) {
    // console.log('goToNextStepper from', state.currentStep)
    if (state.currentStep < state.completedCheckinSteps.length) {
      const targetStep = state.currentStep + 1
      const targetSectionName = state.completedCheckinSteps[targetStep-1].name
      // console.log(`  - to ${targetStep} targetSectionName`, targetSectionName)
      commit('SET_CURRENT_STEP', targetStep)
      router.push({ name: `checkin${targetSectionName.charAt(0).toUpperCase() + targetSectionName.slice(1)}` })
    }
  },
  goToPrevStepper({ commit, state }) {
    // console.log('goToPrevStepper from', state.currentStep)
    if (state.currentStep > 1) {
      const targetStep = state.currentStep - 1
      const targetSectionName = state.completedCheckinSteps[targetStep-1].name
      // console.log(`  - to ${targetStep} targetSectionName`, targetSectionName)
      commit('SET_CURRENT_STEP', targetStep)
      router.push({ name: `checkin${targetSectionName.charAt(0).toUpperCase() + targetSectionName.slice(1)}` })
    }
  },
}
